export const buildProvenance = { "commitHash": "70f55cc83d82e68af5bd2694bf4f715bc1efb98d", "branchName": "refs/heads/release/2025.1", "buildDate": "2025-05-12T06:38:34.154Z", "version": "2025.1.10115" };
